import React from 'react'
import LKButton from '../shared/LKButton'
import { DocumentTitle } from 'shared'
import LKModal, { LKModalContainer, actions as LKModalActions } from '../shared/LKModal'

import container from './container'
import FilePreview from './FilePreview'
import { translateWM } from './helpers'
import { ViewFilesParams } from '@lk/api'
import { viewFile } from 'src/store/linkedFiles'

const FILE_DETAILS_MODAL = 'FILE_DETAILS_MODAL'

// @ts-ignore
export const openFileDetails = (modalParams) => LKModalActions.open({ modalParams, name: FILE_DETAILS_MODAL })

// @ts-ignore
@LKModalContainer(FILE_DETAILS_MODAL)
// @ts-ignore
@container
class FileDetails extends React.Component<any> {
  state = {
    isFetching: false,
  }

  get params() {
    return this.props.params.modalParams || this.props.match.params
  }

  handleDownload = () => {
    const { ID, hash, type } = this.params
    this.props.downloadRemote({ ID, hash, extension: type })
  }

  handleOpen = async () => {
    const { ID, hash } = this.params

    try {
      const fileDetailsResult = await this.props.fileDetails({
        FileID: ID,
        HashSum_FileID_: hash,
      } as ViewFilesParams)
      const payload = fileDetailsResult.payload

      if (viewFile.fulfilled.match(fileDetailsResult)) {
        window.open(payload.url, '_blank', 'width=900,height=800')
      } else {
        throw payload
      }
    } catch (error) {
      this.props.openErrorModal(error)
    }
  }

  render() {
    const { modalInstanceName, error, contentType } = this.props
    const { type, ID, hash } = this.params

    if (error) {
      // temp
      return error.Text
    }

    // TODO: LKModal is missing name
    return (
      <>
        <DocumentTitle title="File" />
        {/** @ts-ignore */}
        <LKModal
          name={modalInstanceName}
          icon="preview"
          heading="File"
          size="sm-3"
          footer={
            // @ts-ignore
            <LKModal.Footer>
              {/** @ts-ignore */}
              <LKButton alias="no_icon" onClick={this.handleOpen}>
                {translateWM('ცალკე გახსნა')}
              </LKButton>

              {/** @ts-ignore */}
              <LKButton alias="download" onClick={this.handleDownload}>
                {translateWM('cmd_lfl_download')}
              </LKButton>
              {/** @ts-ignore */}
            </LKModal.Footer>
          }
        >
          <FilePreview
            isFetching={this.state.isFetching}
            type={type || contentType}
            previewProps={{ FileID: ID, HashSum_FileID_: hash }}
          />
        </LKModal>
      </>
    )
  }
}

export default FileDetails
